import React, { useState, useRef, useEffect } from 'react';
import styles from './CallerComponent.module.css';
import { FaEllipsisV } from 'react-icons/fa'; // Install if not done: npm install react-icons

function AudioPlayer({ url, fileName }) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [showMenu, setShowMenu] = useState(false);
  const audioRef = useRef(null);

  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const updateProgress = () => {
    const currentTime = audioRef.current.currentTime;
    const duration = audioRef.current.duration;
    setProgress((currentTime / duration) * 100);
  };

  const handleSeek = (e) => {
    const width = e.target.clientWidth;
    const clickX = e.nativeEvent.offsetX;
    const duration = audioRef.current.duration;
    audioRef.current.currentTime = (clickX / width) * duration;
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName || 'audio.wav';
    link.click();
    setShowMenu(false);
  };

  useEffect(() => {
    const audioElement = audioRef.current;
    audioElement.addEventListener('timeupdate', updateProgress);
    return () => {
      audioElement.removeEventListener('timeupdate', updateProgress);
    };
  }, []);

  return (
    <div className={styles.audioPlayer}>
      <audio ref={audioRef} src={url}></audio>
      
      <button className={styles.audioButton} onClick={togglePlayPause}>
        {isPlaying ? '❚❚' : '▶'}
      </button>

      <div className={styles.audioProgress} onClick={handleSeek}>
        <div
          className={styles.audioProgressBar}
          style={{ width: `${progress}%` }}
        ></div>
      </div>

    
      <div className={styles.menuWrapper}>
        <FaEllipsisV className={styles.menuIcon} onClick={() => setShowMenu(!showMenu)} />
        {showMenu && (
          <div className={styles.menu}>
            <button onClick={handleDownload}>Download</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default AudioPlayer;
